import RestService from '../services/rest';

async function getAllSupplierTelecom(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/SupplierTelecom/all?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getSupplierTelecomOptions(search) {
  return RestService.getAuthenticated(
    `panel/SupplierTelecom/options?search=${search}`,
  );
}

async function createSupplierTelecom(newSupplierTelecom) {
  return RestService.postAuthenticated(
    'panel/SupplierTelecom/create', newSupplierTelecom,
  );
}

async function updateSupplierTelecom(updSupplierTelecom) {
  return RestService.putAuthenticated(
    'panel/SupplierTelecom/update', updSupplierTelecom,
  );
}

export default {
  getAllSupplierTelecom,
  getSupplierTelecomOptions,
  createSupplierTelecom,
  updateSupplierTelecom,
};
